// Static demo data for Guest Preview Mode
// This data is NOT connected to any real database or user accounts

export const DEMO_PUBLISHED_EVENT = {
  id: 'demo-published-event-001',
  title: 'Summer Music Festival 2026',
  status: 'Published',
  category: 'Festival',
  city: 'Austin',
  state: 'Texas',
  publishedDay: '2026-06-15',
  publishedTime: '4:00 PM',
  description: 'A three-day outdoor music festival featuring local and national artists across multiple stages.',
  location: 'Zilker Park',
  tags: ['music', 'outdoor', 'festival'],
  hold1: { status: 'Active', plannerName: 'Demo Planner A' },
  hold2: { status: 'Active', plannerName: 'Demo Planner B' },
  hold3: { status: 'Available' },
  createdAt: '2026-01-15T10:00:00Z',
  createdBy: 'demo-user',
  isDemo: true
};

export const DEMO_PRIVATE_EVENT = {
  id: 'demo-private-event-001',
  title: "Jude's Pool Party",
  status: 'Draft',
  category: 'Social',
  city: 'Fort Lauderdale',
  state: 'FL',
  description: 'Summer pool party with friends. DJ, catering, and games. Invite-only — 40 guests max.',
  location: '742 Wilton Dr, Wilton Manors',
  tags: ['pool-party', 'summer', 'friends'],
  createdAt: '2026-03-15T14:00:00Z',
  createdBy: 'demo-user',
  isDemo: true,
  isPrivate: true
};

export const DEMO_GROUP = {
  id: 'demo-group-001',
  name: 'Austin Event Planners',
  description: 'A collaborative group for event planners in the Austin area to share resources and coordinate.',
  memberCount: 12,
  members: [
    { id: 'demo-member-1', fullName: 'Sarah Johnson', username: 'sarahj' },
    { id: 'demo-member-2', fullName: 'Mike Chen', username: 'mikec' },
    { id: 'demo-member-3', fullName: 'Emily Davis', username: 'emilyd' }
  ],
  createdAt: '2026-01-01T08:00:00Z',
  isDemo: true
};

export const DEMO_PLANNER_CIRCLE = {
  id: 'demo-circle-001',
  name: 'Festival Coordinators Network',
  description: 'Private circle for festival and large event coordinators to share insights and collaborate.',
  memberCount: 8,
  members: [
    { id: 'demo-member-4', fullName: 'Alex Rivera', username: 'alexr' },
    { id: 'demo-member-5', fullName: 'Jordan Lee', username: 'jordanl' }
  ],
  createdAt: '2026-01-10T14:00:00Z',
  isDemo: true
};

export const DEMO_CONVERSATIONS = [
  {
    id: 'demo-conv-001',
    eventTitle: 'Summer Music Festival 2026',
    eventId: 'demo-published-event-001',
    participants: ['Demo Planner A', 'Demo Planner B'],
    lastMessage: 'Looking forward to coordinating on the venue setup!',
    lastMessageAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(), // 2 hours ago
    unreadCount: 2,
    isDemo: true
  }
];

export const DEMO_ACTIVE_HOLDS = [
  {
    eventId: 'demo-published-event-001',
    eventTitle: 'Summer Music Festival 2026',
    slotNumber: 1,
    status: 'Active',
    expiresAt: new Date(Date.now() + 48 * 60 * 60 * 1000).toISOString(), // 48 hours from now
    isDemo: true
  }
];

export const DEMO_EXPIRING_HOLDS = [];

// Demo user for guest mode
export const DEMO_GUEST_USER = {
  id: 'guest-preview-user',
  fullName: 'Guest User',
  username: 'guest',
  email: 'guest@preview.planblox.app',
  city: 'Austin',
  state: 'Texas',
  isGuest: true,
  creditBalance: 0
};

// Demo draft event for holds section
export const DEMO_DRAFT_EVENT = {
  id: 'demo-draft-event-001',
  title: 'Pride Parade Planning',
  status: 'Draft',
  category: 'Community',
  city: 'Austin',
  state: 'Texas',
  description: 'Annual Pride parade and celebration event.',
  location: 'Downtown Austin',
  tags: ['pride', 'community', 'parade'],
  hold1: { status: 'Active', date: '2026-06-28', plannerName: 'You' },
  hold2: { status: 'Available' },
  hold3: { status: 'Available' },
  createdAt: '2026-03-01T10:00:00Z',
  createdBy: 'demo-user',
  isDemo: true
};

// Demo calendar events for guest preview mode
const today = new Date();
const getDateOffset = (days) => {
  const d = new Date(today);
  d.setDate(d.getDate() + days);
  return d.toISOString().split('T')[0];
};

export const DEMO_CALENDAR_EVENTS = [
  {
    id: 'demo-cal-001',
    title: 'Summer Music Festival 2026',
    category: 'Festival',
    city: 'Austin',
    state: 'Texas',
    publishedDay: getDateOffset(12),
    publishedTime: '4:00 PM',
    location: 'Zilker Park',
    hold1: { status: 'Active', plannerName: 'Sarah J.' },
    hold2: { status: 'Active', plannerName: 'Mike C.' },
    hold3: { status: 'Available' },
    isDemo: true
  },
  {
    id: 'demo-cal-002',
    title: 'Downtown Art Walk',
    category: 'Arts & Culture',
    city: 'Austin',
    state: 'Texas',
    publishedDay: getDateOffset(5),
    publishedTime: '6:00 PM',
    location: 'Congress Ave',
    hold1: { status: 'Active', plannerName: 'Emily D.' },
    hold2: { status: 'Available' },
    hold3: { status: 'Available' },
    isDemo: true
  },
  {
    id: 'demo-cal-003',
    title: 'Food Truck Fridays',
    category: 'Food & Drink',
    city: 'Austin',
    state: 'Texas',
    publishedDay: getDateOffset(3),
    publishedTime: '11:00 AM',
    location: 'Barton Springs',
    hold1: { status: 'Active', plannerName: 'Jordan L.' },
    hold2: { status: 'Active', plannerName: 'Alex R.' },
    hold3: { status: 'Active', plannerName: 'Sarah J.' },
    isDemo: true
  },
  {
    id: 'demo-cal-004',
    title: 'Charity 5K Run',
    category: 'Sports & Fitness',
    city: 'Austin',
    state: 'Texas',
    publishedDay: getDateOffset(18),
    publishedTime: '7:00 AM',
    location: 'Lady Bird Lake Trail',
    hold1: { status: 'Active', plannerName: 'Mike C.' },
    hold2: { status: 'Available' },
    hold3: { status: 'Available' },
    isDemo: true
  },
  {
    id: 'demo-cal-005',
    title: 'Outdoor Movie Night',
    category: 'Entertainment',
    city: 'Austin',
    state: 'Texas',
    publishedDay: getDateOffset(8),
    publishedTime: '8:30 PM',
    location: 'Mueller Lake Park',
    hold1: { status: 'Active', plannerName: 'Emily D.' },
    hold2: { status: 'Active', plannerName: 'Jordan L.' },
    hold3: { status: 'Available' },
    isDemo: true
  },
];

export const DEMO_CALENDAR_PRIVATE_EVENTS = [
  {
    id: 'demo-cal-priv-001',
    title: "Jude's Pool Party",
    category: 'Social',
    city: 'Fort Lauderdale',
    state: 'FL',
    date: getDateOffset(10),
    time: '2:00 PM',
    location: '742 Wilton Dr',
    isPrivate: true,
    isDemo: true
  },
  {
    id: 'demo-cal-priv-002',
    title: 'Birthday Dinner',
    category: 'Personal',
    city: 'Austin',
    state: 'Texas',
    date: getDateOffset(22),
    time: '7:00 PM',
    location: 'Uchi Restaurant',
    isPrivate: true,
    isDemo: true
  },
];

// All demo data combined for easy access
export const GUEST_DEMO_DATA = {
  events: [DEMO_DRAFT_EVENT, DEMO_PUBLISHED_EVENT],
  privateEvents: [DEMO_PRIVATE_EVENT],
  calendarEvents: DEMO_CALENDAR_EVENTS,
  calendarPrivateEvents: DEMO_CALENDAR_PRIVATE_EVENTS,
  groups: [DEMO_GROUP],
  plannerCircles: [DEMO_PLANNER_CIRCLE],
  conversations: DEMO_CONVERSATIONS,
  activeHolds: DEMO_ACTIVE_HOLDS,
  expiringHolds: DEMO_EXPIRING_HOLDS,
  user: DEMO_GUEST_USER
};
